export default {
  label: 'CPF',
  hint: 'Tu banco necesita tu CPF para este pago. Lo transmitimos y no lo conservamos.',
  invalid: 'Ese CPF no es válido. Comprueba los 11 dígitos.',
};
